// extracted by mini-css-extract-plugin
export default {"headerMenuContainer":"CustomMenu_headerMenuContainer__AzCw1","headerMenuOption":"CustomMenu_headerMenuOption__WCLhI","active":"CustomMenu_active__ijn0s"};